import React from 'react'
import { useTranslation } from 'react-i18next'

export default function LocalizedLegalDocument({ documentKey }) {
  const { t } = useTranslation('legal')

  return <div dangerouslySetInnerHTML={{ __html: t(`documents.${documentKey}.html`) }} />
}
